import { Box, Button, Grid, GridItem, Img, Text } from '@chakra-ui/react';
import React, { ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TextField from 'components/fields/TextField';

import Level from 'assets/img/games/new-level-final.png';

import Badges from 'assets/img/games/badges-game-read-format.png';

interface UrlFormProps {
  handleShowComponent: (componentName: string) => void;
  close?: any;
  setItems?: any;
}

const UrlForm: React.FC<UrlFormProps> = ({
  handleShowComponent,
  setItems,
  close,
}) => {
  const [img, setImg] = useState([Level, Badges]);

  const navigate = useNavigate();

  const [input, setInput] = useState<any>({ Link: '', imgId: '', img: '' });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInput((prev: any) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleClickImg = (id: any, img: any) => {
    setInput((prev: any) => {
      return { ...prev, imgId: id, img: img };
    });
  };

  const handleSubmit = () => {
    setItems((prev: any) => {
      const previousId = prev.length > 0 ? prev[prev.length - 1].id : 0;
      const newId = String(parseInt(previousId, 10) + 1);
      return [
        ...prev,
        {
          id: newId,
          name: input?.Link,
          imgId: input.imgId,
          img: input?.img,
        },
      ];
    });
    close(false);
    setInput('');
  };

  return (
    <>
      <Box mt={{ base: '0px', xl: '0px' }}>
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
          <GridItem w="100%">
            <TextField
              mb="0px"
              me="30px"
              w="100%"
              id="Link"
              label="Link*"
              placeholder="eg. Game"
              name="Link"
              onChange={handleChange}
              value={input.Link}
            />
          </GridItem>
          <GridItem w="100%">
            <Text fontSize={14} fontWeight={600} mb={'10px'}>
              Pose NON Player
            </Text>
            <Grid
              templateColumns={{ sm: 'repeat(3, 1fr)', xl: 'repeat(5, 1fr)' }}
              gap={{ sm: '2', xl: '2' }}
            >
              {img.map((img, i) => (
                <GridItem w="100%" key={i}>
                  <Img
                    src={img}
                    data-name="imgId"
                    onClick={() => handleClickImg(i, img)}
                    h={{ sm: '45px', xl: '75px' }}
                    w={{ sm: '45px', xl: '75px' }}
                    borderRadius="50px"
                    boxShadow="1px 3px 17px #332f2f4d"
                  />
                </GridItem>
              ))}
            </Grid>
          </GridItem>
        </Grid>

        <Button
          onClick={handleSubmit}
          bg={'#3311db'}
          _hover={{ bg: '#3311db' }}
          color={'#fff'}
          mt={'20px'}
        >
          Save
        </Button>
      </Box>
    </>
  );
};

export default UrlForm;
